import React, { useContext, useEffect } from 'react';
import { Row, Col, Spinner, Modal, Table, Button } from 'react-bootstrap';
import { useRef } from 'react';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';
export const Invoice = () => {
    const { viewBillModal, setViewBillModal, bill, setBill, getBillLoad, account } = useContext(AppContext);
    const invoice = useRef(null);
    useEffect(() => {
        if (!viewBillModal) {
            setBill(undefined);
        }
    }, [viewBillModal]);
    return (
        <Modal size="xl" show={viewBillModal} backdrop="static" onHide={() => { setViewBillModal(false) }}>
            <Modal.Header closeButton>
                <Modal.Title>Invoice</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    getBillLoad ? (
                        <span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
                    ) : (
                        bill !== undefined ? (
                            <div className='pt-2 mx-2 my-2 p-2' ref={invoice}>
                                {
                                    account !== undefined ? (
                                        <div className="d-grid align-items-center justify-content-center text-center" >
                                            {
                                                account.logo !== "" ? (
                                                    <div className="d-grid text-center justify-content-center">
                                                        <img src={account.logo} style={{ maxWidth: '100px', maxHeight: '100px' }} />
                                                    </div>
                                                ) : ''
                                            }
                                            {
                                                account.name !== "" || account.address !== "" || account.phone_numbers ? (
                                                    <div className="d-grid text-center">
                                                        <span className="f20"><b>{account.name}</b></span>
                                                        <span className="f14" >{account.address}</span>
                                                        <span className="f14" >{account.phone_numbers}</span>
                                                    </div>
                                                ) : ''
                                            }
                                        </div>
                                    ) : ''
                                }
                                <div className="grid1by1 br-2 align-items-center justify-content-between mb-2" >
                                    <div className='d-grid' >
                                        <span className="f14">Customer details</span>
                                        <span className="f14">{bill.customer_name}</span>
                                        <span className="f14">{bill.customer_phone}</span>
                                    </div>
                                    <div className="d-grid align-items-center justify-content-end text-end">
                                        <span className="f14">Invoice details</span>
                                        <span className="f14">{bill.bill_no} : Invoice number</span>
                                        <span className="f14">{bill.created_date} / {bill.created_time} : Date</span>
                                    </div>
                                </div>
                                <Table className="tbl-bill-print" bordered>
                                    <thead>
                                        <tr  >
                                            <th  ><span className="tp0" >No</span></th>
                                            <th ><span className="tp0" >Services</span></th>
                                            <th className="text-end" ><span className="tp0" >SC</span></th>
                                            <th className="text-end" ><span className="tp0" >TC</span></th>
                                            <th className="text-end" ><span className="tp0" >Qty</span></th>
                                            <th className="text-end" ><span className="tp0" >Total</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            bill.bill_services !== undefined ? (
                                                Object.keys(bill.bill_services).length > 0 ? (
                                                    Object.keys(bill.bill_services).map((t_ser, ts_i) => (
                                                        <tr key={`bill_s_${ts_i}`}>
                                                            <td><span className="f16 mb-1" >{ts_i + 1}</span></td>
                                                            <td><span className="f14" >{bill.bill_services[t_ser].service_name}</span></td>
                                                            <td className="text-end" ><span className="f14" >{parseFloat(bill.bill_services[t_ser].akshaya_charge).toFixed(2)}</span></td>
                                                            <td className="text-end" ><span className="f14" >{parseFloat(bill.bill_services[t_ser].govt_charge).toFixed(2)}</span></td>
                                                            <td className="text-end" ><span className="f14" >{bill.bill_services[t_ser].quantity}</span></td>
                                                            <td className="text-end" ><span className="f14" >{parseFloat(bill.bill_services[t_ser].amount).toFixed(2)}</span></td>
                                                        </tr>
                                                    ))
                                                ) : ''
                                            ) : ''
                                        }
                                        {
                                            bill.bill_payments !== undefined ? (
                                                Object.keys(bill.bill_payments).length > 0 ? (
                                                    Object.keys(bill.bill_payments).map((r_pay, r_pay_i) => (
                                                        <tr key={`r_pay_${r_pay_i}`}>
                                                            <td colSpan={5} className="text-end" ><span className="tp1 f16" >{bill.bill_payments[r_pay].name}</span></td>
                                                            <td className="text-end" ><span className="f14" >{parseFloat(bill.bill_payments[r_pay].amount).toFixed(2)}</span></td>
                                                        </tr>
                                                    ))
                                                ) : ''
                                            ) : ''
                                        }
                                        <tr>
                                            <td colSpan={5} className="text-end" ><span className="f16" ><b>Total</b></span></td>
                                            <td className="text-end" ><span className="f16" >{bill !== undefined ? parseFloat(bill.bill_total).toFixed(2) : '--'}</span></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        ) : (
                            <span className="p-2" >Not found!</span>
                        )

                    )
                }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => generatePDF(invoice, 'invoice' + bill.bill_no + '.pdf')} className="btn btn-t1 br-2"><i className="bi bi-file-pdf"></i> PDF</Button>
                <ReactToPrint
                    trigger={() => <button className="btn btn-t1 br-2"><i className="bi bi-printer"></i> Print</button>}
                    content={() => invoice.current}
                />
            </Modal.Footer>
        </Modal>
    );
};
